export default "Irrigation, séchage, froid agricole : vos puissances souscrites sont-elles calées sur vos saisons ? Audit gratuit du TURPE de chaque compteur de l'exploitation, sans changer de fournisseur.";
